var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgStampApprove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5382_187319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.875H3.29999C3.29999 11.5 4.48415 11.5 6.45832 11.5C10.8 11.5 7.46665 7.675 7.46665 5.83333C7.46665 4.94928 7.81784 4.10143 8.44296 3.47631C9.06809 2.85119 9.91593 2.5 10.8 2.5C11.684 2.5 12.5319 2.85119 13.157 3.47631C13.7821 4.10143 14.1333 4.94928 14.1333 5.83333C14.1333 7.675 10.8 11.5 15.1417 11.5C17.1158 11.5 18.3 11.5 18.3 14.875Z",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.96664 17.5H16.6333",
    stroke: "#002244",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3667 10.0349L20.7038 9.6846C21.0708 10.0378 21.1005 10.6151 20.7718 11.0042L14.2894 18.6771C13.9407 19.09 13.3211 19.1364 12.9146 18.7802L8.92933 15.2874C8.52415 14.9323 8.48771 14.3144 8.84834 13.9141L10.1814 12.4346C10.5627 12.0114 11.2255 12.0083 11.6108 12.4279L13.437 14.4167L18.9197 9.24376M20.3667 10.0349L18.9197 9.24376M20.3667 10.0349L20.7038 9.6846L20.2527 9.25039C19.8813 8.89291 19.2946 8.88999 18.9197 9.24376M20.3667 10.0349L19.2628 9.60744L18.9197 9.24376",
    fill: "#28BA59",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5382_187319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.799988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgStampApprove);
export default __webpack_public_path__ + "static/media/svg_stamp_approve.91cbf81a72abb04b53da5446a7c8ab54.svg";
export { ForwardRef as ReactComponent };